import React, { Component } from 'react'
import { Translate, withLocalize } from 'react-localize-redux';
import { validateField } from '../../../utils/index.jsx';
import FieldSherwood from '../../general/FieldSherwood';
import { reduxForm, Field } from 'redux-form';
import { ButtonAdd, ButtonSave, ButtonCancel } from '../../general/mini_components';
import { Grid, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import OrderableTable from '../../general/OrderableTable';
import FieldGroup from './field_group';


const SECTION_FORM = {
    "name" : {
        required : true,
        type:"text",
        label:"investigation.create.sections.section",
        shortLabel: "investigation.table.name",
        validation : "textMin2"
    },
    "type":{
        required : false,
        type:"select",
        label:"investigation.create.edc.section_type",
        shortLabel: "investigation.create.edc.section_type_short",
        validation : "notEmpty",
        defaultOption:{"text" : "Inline", "value" : 0},
        options:[
            {"label" : "Inline", "value" : 0},
            {"label" : "Popup", "value" : 1}
        ]
    },
    "pdfDisplayFormat":{
        required : false,
        type:"select",
        label:"investigation.create.sections.pdf_display_format",
        shortLabel: "investigation.table.pdf_format",
        validation : "notEmpty",
        defaultOption:{"text" : "Label: Value", "value" : "label_value"},
        options:[
            {"label" : "Label: Value", "value" : "label_value"},
            {"label" : "Table Format", "value" : "table"},
            {"label" : "Paragraph Format", "value" : "paragraph"},
            {"label" : "List Format", "value" : "list"}
        ]
    }
}

const FIELD_GROUP_TABLE_FORM = {
    "name": {
        shortLabel: "investigation.table.name",
        type: "text"
    },
    "displayMode": {
        shortLabel: "investigation.create.edc.field_group.display_mode",
        type: "text"
    },
    "number_fields": {
        shortLabel: "investigation.create.edc.number_fields",
        type: "text"
    }
}


/**
 * A section of a EDC, each section contains field groups which in turn contain fields.
 */
class Section extends Component{
    constructor(props){
        super(props);

        this.addFieldGroup = this.addFieldGroup.bind(this);
        this.renderFieldGroups = this.renderFieldGroups.bind(this);
        this.deleteFieldGroup = this.deleteFieldGroup.bind(this);
        this.editFieldGroup = this.editFieldGroup.bind(this);
        this.handleNewSection = this.handleNewSection.bind(this);
        this.callBackFieldGroup = this.callBackFieldGroup.bind(this);
        this.closeFieldGroup = this.closeFieldGroup.bind(this);

        const initialState = { addingFieldGroup: false, fieldGroups: [], editingFieldGroupIndex: false };

        if(props.initialData){
            if(props.initialData.fieldGroups && props.initialData.fieldGroups.length > 0){
                // New format: already has fieldGroups
                this.state = Object.assign({}, initialState, {
                    fieldGroups: props.initialData.fieldGroups
                });
            } else if(props.initialData.fields && props.initialData.fields.length > 0){
                // Reconstruct fieldGroups from flat fields array.
                // Fields with groupName metadata are grouped together;
                // fields without it fall into a single default group.
                const groupMap = {};
                props.initialData.fields.forEach((field) => {
                    const gName = field.groupName || (props.initialData.name || "Default Group");
                    if(!groupMap[gName]){
                        groupMap[gName] = {
                            name: gName,
                            description: "",
                            repeats: field.groupRepeats || props.initialData.repeats || false,
                            displayMode: field.groupDisplayMode || "inline",
                            order: field.groupOrder !== undefined ? field.groupOrder : Object.keys(groupMap).length,
                            fields: []
                        };
                    }
                    // Strip group metadata from the field copy
                    const { groupName, groupOrder, groupRepeats, groupDisplayMode, ...cleanField } = field;
                    groupMap[gName].fields.push(cleanField);
                });
                const reconstructedGroups = Object.values(groupMap)
                    .sort((a, b) => (a.order || 0) - (b.order || 0));
                this.state = Object.assign({}, initialState, {
                    fieldGroups: reconstructedGroups
                });
            } else {
                this.state = initialState;
            }
        } else {
            this.state = initialState;
        }
    }

    addFieldGroup(){
        let tempState = {...this.state};
        tempState.addingFieldGroup = true;
        tempState.editingFieldGroupIndex = false;
        this.setState(tempState);
    }

    deleteFieldGroup(index){
        console.log("Delete Field Group", index);
        let tempState = {...this.state};
        tempState.fieldGroups.splice(index, 1);
        this.setState(tempState);
    }

    editFieldGroup(index){
        console.log("Edit Field Group", index);
        let tempState = {...this.state};
        tempState.addingFieldGroup = false;
        tempState.editingFieldGroupIndex = index;
        this.setState(tempState);
    }

    closeFieldGroup(){
        let tempState = {...this.state};
        tempState.addingFieldGroup = false;
        tempState.editingFieldGroupIndex = false;
        this.setState(tempState);
    }

    callBackFieldGroup(fieldGroup){
        console.log("New/Edit field group!", fieldGroup);
        let tempState = {...this.state};
        tempState.addingFieldGroup = false;

        if(Number.isInteger(this.state.editingFieldGroupIndex)){
            tempState.fieldGroups[this.state.editingFieldGroupIndex] = fieldGroup;
            tempState.editingFieldGroupIndex = false;
        } else {
            fieldGroup.order = tempState.fieldGroups.length;
            tempState.fieldGroups.push(fieldGroup);
        }
        this.setState(tempState);
    }

    orderUpdate(dragDrop){
        console.log("Parent reorder");
        let tempState = {...this.state};
        const result = Array.from(tempState.fieldGroups);
        const [removed] = result.splice(dragDrop.source.index, 1);
        result.splice(dragDrop.destination.index, 0, removed);
        tempState.fieldGroups = result.map((group, index) => {group.order = index; return group;});
        this.setState(tempState);
    }

    renderFieldGroups(){
        if(this.state.fieldGroups.length > 0){
            const arrayHeader = Object.keys(FIELD_GROUP_TABLE_FORM).map(key => {
                const value = FIELD_GROUP_TABLE_FORM[key];
                return { id: key, alignment: "right", label: <Translate id={value.shortLabel} /> }
            });
            const rows = this.state.fieldGroups.sort((a, b) => a.order - b.order).map((group, index) => {
                return {
                    id: index,
                    name: group.name,
                    displayMode: group.displayMode || "inline",
                    number_fields: group.fields ? group.fields.length : 0
                };
            });
            return(
                <OrderableTable onDragEnd={(result) => this.orderUpdate(result)}
                    orderUpdate={(dragDrop) => this.orderUpdate(dragDrop)}
                    droppableId="droppable-field-groups" noSelectable
                    titleTable={<Translate id="investigation.create.edc.field_group.field_groups" />}
                    headCells={arrayHeader}
                    rows={rows}
                    actions={[
                        {"type" : "delete", "func" : (index) => this.deleteFieldGroup(index) },
                        {"type" : "edit", "func" : (index) => this.editFieldGroup(index) }
                    ]}
                />
            )
        }
        else{
            return null;
        }
    }

    handleNewSection(values){
        console.log("handleNewSection: "+JSON.stringify(values));
        if(this.state.fieldGroups.length === 0){
            alert("Please add at least one field group");
        }
        else{
            // Preserve original section properties (uuid, order, etc.) when editing
            let newValues = this.props.initialData
                ? Object.assign({}, this.props.initialData, values)
                : Object.assign({}, values);
            newValues.fieldGroups = [...this.state.fieldGroups];
            // Flatten fieldGroups into a flat fields array for backend compatibility.
            // Each field is annotated with its group metadata so the structure
            // can be reconstructed when loading.
            let flatFields = [];
            let fieldOrder = 0;
            this.state.fieldGroups
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .forEach((group) => {
                    const groupFields = (group.fields || [])
                        .sort((a, b) => (a.order || 0) - (b.order || 0))
                        .map((field) => ({
                            ...field,
                            order: fieldOrder++,
                            groupName: group.name,
                            groupOrder: group.order,
                            groupRepeats: group.repeats || false,
                            groupDisplayMode: group.displayMode || "inline"
                        }));
                    flatFields = flatFields.concat(groupFields);
                });
            newValues.fields = flatFields;
            newValues.type = values.hasOwnProperty("type") ? values.type : 0;
            newValues.repeats = values.hasOwnProperty("repeats") ? values.repeats : false;
            newValues.pdfDisplayFormat = values.hasOwnProperty("pdfDisplayFormat") ? values.pdfDisplayFormat : "label_value";
            this.props.callBackNewSection(newValues);
        }
    }

    componentDidMount(){
        if(this.props.initialData){
            console.log("Init Data");
            this.props.initialize(this.props.initialData);
        }
    }

    /**
     * Collect all fields from field groups with a lower order than the given index.
     * Used to populate the "Source field" selector for forwarded fields.
     */
    getPreviousGroupFields(currentGroupIndex){
        const fields = [];
        const sortedGroups = [...this.state.fieldGroups].sort((a, b) => (a.order || 0) - (b.order || 0));
        for(let i = 0; i < sortedGroups.length; i++){
            // Stop when we reach the current group's order
            if(i >= currentGroupIndex) break;
            const group = sortedGroups[i];
            if(group.fields){
                group.fields.forEach(field => {
                    fields.push({ value: field.name, label: `${group.name} → ${field.label || field.name}` });
                });
            }
        }
        return fields;
    }

    renderFieldGroupForm(){
        if(this.state.addingFieldGroup){
            const previousFields = this.getPreviousGroupFields(this.state.fieldGroups.length);
            return (
                <Grid item xs={12}>
                    <FieldGroup
                        callBackFieldGroup={this.callBackFieldGroup}
                        closeFieldGroup={this.closeFieldGroup}
                        previousGroupFields={previousFields}
                    />
                </Grid>
            );
        } else if(Number.isInteger(this.state.editingFieldGroupIndex)){
            const previousFields = this.getPreviousGroupFields(this.state.editingFieldGroupIndex);
            return (
                <Grid item xs={12}>
                    <FieldGroup
                        initialData={this.state.fieldGroups[this.state.editingFieldGroupIndex]}
                        callBackFieldGroup={this.callBackFieldGroup}
                        closeFieldGroup={this.closeFieldGroup}
                        previousGroupFields={previousFields}
                    />
                </Grid>
            );
        }
        return null;
    }

    render(){
        const title = this.props.initialData ? <Translate id="investigation.create.edc.section.edit_section" /> :  <Translate id="investigation.create.edc.section.new" />
        const saveText = this.props.initialData ? <Translate id="investigation.create.edc.section.edit_section" /> : <Translate id="investigation.create.edc.section.add" />

        // When adding or editing a field group, show the FieldGroup form instead
        if(this.state.addingFieldGroup || Number.isInteger(this.state.editingFieldGroupIndex)){
            return (
                <Grid item container xs={12}>
                    {this.renderFieldGroupForm()}
                </Grid>
            );
        }

        return (
            <Grid item container xs={12}>
                <Grid item xs={12}>
                    <form onSubmit={this.props.handleSubmit(values => this.handleNewSection(values))} >
                        <Field type="text" name="name" fullWidth label="name" required={true} component={FieldSherwood} />
                        <div>
                            <Field type="select" name="type" label="Section Type"
                                   component={FieldSherwood}
                                   defaultOption={SECTION_FORM.type.defaultOption}
                                   options={SECTION_FORM.type.options} />
                        </div>
                        <div>
                            <Field type="select" name="pdfDisplayFormat" label="PDF Display Format"
                                   component={FieldSherwood}
                                   defaultOption={SECTION_FORM.pdfDisplayFormat.defaultOption}
                                   options={SECTION_FORM.pdfDisplayFormat.options} />
                        </div>
                        <div style={{paddingTop:"40px"}}>
                            <Typography variant="body2" color="textPrimary" component="span">
                                <Translate id="investigation.create.edc.field_group.add" />
                            </Typography>
                            <ButtonAdd type="button" data-testid="add-field-group" onClick={this.addFieldGroup}
                                show={true}>
                            </ButtonAdd>
                        </div>
                        { this.renderFieldGroups() }
                        <div style={{paddingTop:"40px"}}>
                            <ButtonSave disabled={this.state.fieldGroups.length === 0} data-testid="add-section" type="submit">Add Section</ButtonSave>
                            <ButtonCancel onClick={this.props.closeNewSection} data-testid="cancel-section" style={{marginLeft:'1rem'}}
                                type="button">Cancel</ButtonCancel>
                        </div>
                    </form>
                </Grid>
            </Grid>
        )
    }
}

function validate(values){
    console.log("Validate");
    const errors = {};

    Object.keys(SECTION_FORM).forEach(key => {
        console.log(key);
        const validation = validateField({value : values[key], validation:SECTION_FORM[key].validation, required:SECTION_FORM[key].required})
        if(!validation.result){
            errors[key] = validation.messageCode;
        }
    });
    return errors;
}

Section.propTypes = {
    initialData: PropTypes.object,
    callBackNewSection: PropTypes.func.isRequired,
    closeNewSection: PropTypes.func.isRequired
};

export default withLocalize(reduxForm({
    validate : validate,
    form : 'section'
})(Section))
